import { useState, useCallback } from "react";
import { useTestGet } from "./TestGet";
import { useTestPost } from "./TestPost";
import { createId } from "../utils/cuid2Utils";

import { Transition } from "react-transition-group";
import { useRef } from "react";

const TestPage = () => {
  const [result, setResult] = useState(null);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  // fading button
  const nodeRef = useRef(null);
  const [inProp, setInProp] = useState(false);
  const duration = 1000;

  const defaultStyle = {
    transition: `opacity ${duration}ms ease-in-out`,
    opacity: 0,
  };

  const transitionStyles = {
    entering: { opacity: 0.5 },
    entered: { opacity: 1 },
    exiting: { opacity: 0.5 },
    exited: { opacity: 0 },
  };

  // end fading button

  // hooks must be called at the top level
  // const {
  //   loading: postLoading,
  //   data: postData,
  //   error: postError,
  //   reset: resetPost,
  // } = useTestPost();

  // const {
  //   loading: getLoading,
  //   data: getData,
  //   error: getError,
  //   reset: resetGet,
  // } = useTestGet();

  const runTestPost = useTestPost();
  const runTestGet = useTestGet();

  const clearMessages = useCallback(() => {
    setResult(null);
    setMessage(null);
    setError(null);
  }, []);

  const handleGet = async () => {
    clearMessages();
    try {
      const response = await runTestGet();
      setResult(response);
      setMessage(response?.data?.message);
    } catch (e) {
      setError(e?.message || "GET failed");
    }
  };

  const handlePost = async () => {
    clearMessages();
    try {
      const response = await runTestPost();
      setResult(response); // ?? postData ?? { success: true });
      setMessage(response?.data?.message);
    } catch (e) {
      setError(e?.message || "POST failed");
    }
  };

  // const display = result;

  // console.log(
  //   createId(), // wjfazn7qnd
  //   createId(), // cerhuy9499
  //   createId() // itp2u4ozr4
  // );

  return (
    <div>
      <h2>Welcome to the Test Page!</h2>

      <div class="test-page">
        <button
          className="test btn w-50"
          type="button"
          onClick={handleGet}
          // disabled={getLoading}
        >
          Test Get
        </button>

        <button
          className="test btn w-50 mt-2"
          type="button"
          onClick={handlePost}
          // disabled={postLoading}
        >
          Test Post
        </button>

        <div class="mt-2">
          <p>
            <span>CUID2: </span>
            {createId()}
          </p>
        </div>
        {error && <div className="text-danger mt-3">{error}</div>}
        {/* 
        {display && (
          <pre
            className="mt-3 bg-light p-2 rounded"
            style={{ whiteSpace: "pre-wrap" }}
          >
            {typeof display === "string"
              ? display
              : JSON.stringify(display, null, 2)}
          </pre>
        )} */}

        {result && (
          <div>
            <p>{typeof message === "string" ? message : ""}</p>
            <pre
              className="mt-3 bg-light p-2 rounded"
              style={{ whiteSpace: "pre-wrap" }}
            >
              {typeof result === "string"
                ? result
                : JSON.stringify(result, null, 2)}
            </pre>
          </div>
        )}

        <Transition nodeRef={nodeRef} in={inProp} timeout={duration}>
          {(state) => (
            <div
              ref={nodeRef}
              style={{
                ...defaultStyle,
                ...transitionStyles[state],
              }}
            >
              I'm a fade Transition!
            </div>
          )}
        </Transition>
        <button onClick={() => setInProp(!inProp)}>Toggle Fade</button>
      </div>
    </div>
  );
};

export default TestPage;

// Orig
// import React, { useState } from "react";
// import { testGet } from "../../api/diag_test/TestGet";
// import { testPost } from "../../api/diag_test/TestPost";
// import { userLogout } from "../../api/auth/UserAuth";

// const TestPage = () => {
//   const [error, setError] = useState(null);
//   const [success, setSuccess] = useState(null);

//   const handleSubmit = async (e) => {
//     e.preventDefault(); // prevent default form submission refresh
//     console.log(e);
//     setError(null);
//     setSuccess(null);

//     let result = null;
//     try {
//       if (e.target.name.toUpperCase() === "POSTTEST") {
//         result = await testPost(); //.then((value) => {
//         //   return value;
//         // });
//       } else if (e.target.name.toUpperCase() === "LOGOUT") {
//         result = await userLogout();
//       } else {
//         result = await testGet(); //.then((value) => {
//         //   return value;
//         // }); //->then(result){console.log(result)};
//       }
//       console.log(result);
//       // setSuccess(
//       //     response.json();
//       // );
//       // setSuccess(result);
//       // console.log(result);
//     } catch (err) {
//       console.error(err);
//       // setError(result);
//     } finally {
//     }
//   };

//   return (
//     // <form className="p-4 border rounded">
//     <div>
//       <h2>Welcome to the Test Page!</h2>
//       <div>
//         <button
//           className="btn btn-dark w-100"
//           id="gettest"
//           name="gettest"
//           type="submit"
//           onClick={handleSubmit}
//         >
//           Test Get
//         </button>
//         <button
//           className="btn btn-dark w-100"
//           id="posttest"
//           name="posttest"
//           type="submit"
//           onClick={handleSubmit}
//         >
//           Test Post
//         </button>
//         <button
//           className="btn btn-dark w-100"
//           id="logout"
//           name="logout"
//           type="submit"
//           onClick={handleSubmit}
//         >
//           Logout
//         </button>
//         {/* Error message */}
//         {error && <div className="text-danger mt-2">{error}</div>}

//         {/* Success message */}
//         {success && <div className="text-success mt-2">{success}</div>}
//       </div>
//     </div>
//     // </form>
//   );
// };

// export default TestPage;
